/**
 * Parse a disappear_at string ("YYYY-MM-DD HH:MM:SS" UTC) to a Unix ms timestamp.
 *
 * @param {string} disappearAt Value the server stores for the message.
 * @returns {number} Milliseconds, or NaN when the value is missing or unreadable.
 */
export const parseDisappearAtMs = disappearAt => {
    if (!disappearAt) return NaN;
    return new Date(String(disappearAt).replace(' ', 'T') + 'Z').getTime();
};

// "YYYY-MM-DDTHH:MM:SS" of an ISO string, before its milliseconds and zone.
const ISO_SECONDS_LENGTH = 19;

/**
 * Format a Unix ms timestamp the way the server stores disappear_at ("YYYY-MM-DD HH:MM:SS" UTC).
 *
 * @param {number} ms Milliseconds.
 * @returns {string} The server text.
 */
export const formatDisappearAtMs = ms => new Date(ms).toISOString().slice(0, ISO_SECONDS_LENGTH).replace('T', ' ');

/**
 * Disappearing time of a message sent at `sentAt` instead of now: the chat timer counts
 * from the real sending time, so the offset now gives is moved there.
 *
 * @param {string|undefined} disappearAtNow Server text for a message sent now.
 * @param {number} sentAt Sending time, epoch milliseconds.
 * @param {number} now Current time, epoch milliseconds.
 * @returns {number|null} Epoch milliseconds, or null when the chat does not disappear.
 */
export const shiftDisappearAt = (disappearAtNow, sentAt, now = Date.now()) => {
    const expiry = parseDisappearAtMs(disappearAtNow);
    return Number.isFinite(expiry) ? Number(sentAt) + (expiry - now) : null;
};
